module.exports = __webpack_public_path__ + "media/images/city_img/icon7-1c414c2d2a59099e2e8a5a69d7d0ae92.png";